import { render, staticRenderFns } from "./StudentVerificationDocuments.vue?vue&type=template&id=b5a1cf0c&"
import script from "./StudentVerificationDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentVerificationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports